import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { AccessRange, ActiveInactiveFor, KeyValues3, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { LocationManagementService } from '../../../service/location-management.service';
import { LocationConfigurationComponent } from '../../popups/location-configuration/location-configuration.component';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss']
})
export class LocationsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table"];
  wrapper: KeyValues3[]; roots: KeyValues3[];
  parentId: string = ''; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private locationManagementService: LocationManagementService, private route: ActivatedRoute, private router: Router, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.parentId = routeParams.id;
      if (this.parentId == '0' || this.parentId == '')
        this.parentId = '';
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.locationManagementService.getLocationsWithRoots(this.parentId).subscribe(result => {
      this.wrapper = result[0];
      this.roots = result[1];
    });
  }

  onActiveInactiveStatus(strId: string) {
    this.locationManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Location).subscribe(result => {
      if (result == Status.Success) {
        const updatedItem = this.wrapper.find(x => x.key == strId);
        updatedItem.v2 = updatedItem.v2 == "1" ? "0" : "1";
      }
    });
  }

  openCreateEditPopup(id: string) {
    const modalRef = this.modalService.open(LocationConfigurationComponent, { ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.parentId = this.parentId;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
      }
    });
  }

  onRoute(key, isNavigate) {
    if (isNavigate) {
      if (key == '') {
        this.router.navigate(['/countries' + this.localService.basicParamsString]);
      } else {
        this.router.navigate(['/locations' + this.localService.basicParamsString, key]);
      }
    }
  }

  onGenerateRent(locationId: string) {
    let accessRange: AccessRange = this.roots.length == 4 ? AccessRange.Constituency : this.roots.length == 3 ? AccessRange.District : AccessRange.State;
    this.configurationManagementService.generateRent(undefined, locationId, accessRange).subscribe(result => {
      this.localService.showMessageByStatus(result);
    });
  }
}
